const GA_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;

export function isGaEnabled() {
  return Boolean(GA_ID && typeof window !== "undefined");
}

export function initGtag() {
  if (!GA_ID || typeof window === "undefined" || window.gtag) return;

  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() {
    window.dataLayer.push(arguments);
  };
  window.gtag("js", new Date());
  window.gtag("config", GA_ID, {
    send_page_view: false,
    anonymize_ip: true,
  });

  const s = document.createElement("script");
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(s);
}

export function sendPageView(path) {
  if (!GA_ID || !window.gtag) return;
  window.gtag("config", GA_ID, {
    page_path: path,
  });
}

export function sendWebVital(metric) {
  if (!GA_ID || !window.gtag) return;
  window.gtag("event", metric.name, {
    event_category: "Web Vitals",
    event_label: metric.id,
    value: Math.round(
      metric.name === "CLS"
        ? (metric.delta ?? metric.value) * 1000
        : metric.delta ?? metric.value,
    ),
    non_interaction: true,
  });
}
